import { useContext } from 'react';
import { AuthContext } from 'react-oauth2-code-pkce';
import { removeAuthToken } from '../cookies/authStorage';
import { removeUserDetails } from '../cookies/userStorage';

/**
 * Logs the user out and cleanup their session data.
 */
const useLogOut = (): () => void => {
  const { logOut } = useContext(AuthContext);

  return () => {
    removeAuthToken();
    removeUserDetails();
    localStorage.removeItem('aircraft');
    localStorage.removeItem('bannerSeen');

    logOut();
  };
};

export default useLogOut;
